import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "card modern-card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_5 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "payment-info mb-4" }
const _hoisted_8 = { class: "info-content" }
const _hoisted_9 = { class: "info-row" }
const _hoisted_10 = { class: "info-value" }
const _hoisted_11 = { class: "info-row" }
const _hoisted_12 = { class: "info-value" }
const _hoisted_13 = { class: "info-row" }
const _hoisted_14 = { class: "info-value text-success fw-bold" }
const _hoisted_15 = { class: "info-row" }
const _hoisted_16 = { class: "info-value text-primary fw-bold" }
const _hoisted_17 = {
  key: 0,
  class: "text-center my-4"
}
const _hoisted_18 = { class: "d-flex gap-3 mt-4" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h4", { class: "mb-0" }, " Carte bancaire Rechargement via Stripe ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "spinner-border text-primary" }, null, -1),
              _createElementVNode("p", { class: "mt-3 text-muted" }, "Préparation du paiement...", -1)
            ]))]))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "info-title" }, "Détails du rechargement", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "info-label" }, "Compte prépayé", -1)),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.accountNumber), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "info-label" }, "Solde actuel", -1)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatNumber(_ctx.currentBalance)) + " " + _toDisplayString(_ctx.currency), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "info-label" }, "Montant à recharger", -1)),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatNumber(_ctx.amount)) + " " + _toDisplayString(_ctx.currency), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "info-label" }, "Nouveau solde estimé", -1)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatNumber(_ctx.currentBalance + _ctx.amount)) + " " + _toDisplayString(_ctx.currency), 1)
                    ])
                  ])
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "alert alert-info-custom mb-4" }, " Paiement 100% sécurisé par Stripe · SSL · 3D Secure ", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("div", {
                  id: "payment-element",
                  class: "mb-4"
                }, null, -1)),
                (_ctx.processing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("div", { class: "spinner-border text-primary" }, null, -1),
                      _createElementVNode("p", { class: "mt-2" }, "Traitement du paiement...", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.payWithStripe && _ctx.payWithStripe(...args))),
                    disabled: _ctx.processing,
                    class: "btn btn-success flex-fill py-3 fs-5"
                  }, [
                    (!_ctx.processing)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Payer " + _toDisplayString(_ctx.formatNumber(_ctx.amount)) + " " + _toDisplayString(_ctx.currency), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1),
                          _createTextVNode("Traitement...", -1)
                        ]))]))
                  ], 8, _hoisted_19),
                  _createVNode(_component_router_link, {
                    to: "/prepaid-accounts",
                    class: "btn btn-outline-secondary"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" Annuler ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-center mt-4" }, [
                  _createElementVNode("small", { class: "secure-badge" }, " Paiement sécurisé par Stripe ")
                ], -1))
              ]))
      ])
    ])
  ]))
}